let prefix = '/api/failureType';

function getFailureType() {
    return window.axios.get(prefix);
}

export default {
    getFailureType
  
}